import { useQuery } from '@tanstack/react-query';
import { request } from '../../api/client.js';
import { useAuthStore } from '../../stores/auth.store.js';

/** FX027d (D3): decide se uma ferramenta de apoio está ativa antes de lê-la; ferramenta desligada devolveria 409 no console. */
export function hasActiveModule(
  entries: ReadonlyArray<{ moduleId?: string }> | undefined,
  moduleId: string,
): boolean {
  return (Array.isArray(entries) ? entries : []).some((entry) => entry.moduleId === moduleId);
}

export function useActiveModules() {
  const company = useAuthStore((state) => state.company);
  const user = useAuthStore((state) => state.user);
  const query = useQuery({
    queryKey: ['navigation-modular', `${company?.id}:${user?.id}:${user?.role}:${company?.vertical}`],
    queryFn: () => request<Array<{ moduleId: string; path: string }>>('/modules/navigation'),
    enabled: !!company && !!user,
    retry: false,
    staleTime: 30_000,
  });
  // RCF: ferramentas da empresa sem filtro de papel; distingue "inativa" de "sem permissão".
  const installed = useQuery({
    queryKey: ['installed-modules', `${company?.id}:${user?.id}`],
    queryFn: () => request<string[]>('/modules/installed'),
    enabled: !!company && !!user,
    retry: false,
    staleTime: 30_000,
  });
  return {
    ready: query.isSuccess,
    /** true/false quando a lista da empresa chegou; null enquanto desconhecido. */
    isInstalled: (moduleId: string): boolean | null =>
      installed.isSuccess && Array.isArray(installed.data) ? installed.data.includes(moduleId) : null,
    total: query.isSuccess && Array.isArray(query.data) ? query.data.length : 0,
    isActive: (moduleId: string) => query.isSuccess && hasActiveModule(query.data, moduleId),
  };
}
